import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Users, Award, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  const values = [
    { icon: Heart,  titleKey: 'about.val1_title',  descKey: 'about.val1_desc' },
    { icon: Award,  titleKey: 'about.val2_title',  descKey: 'about.val2_desc' },
    { icon: Zap,    titleKey: 'about.val3_title',  descKey: 'about.val3_desc' },
    { icon: Users,  titleKey: 'about.val4_title',  descKey: 'about.val4_desc' },
  ];

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          <div className="text-center mb-16">
            <h1 className="text-4xl lg:text-5xl font-bold gradient-text mb-6">
              {t('about.title', 'About PSH Store')}
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-400 leading-relaxed">
              {t('about.subtitle', 'Your premier destination for premium products and exceptional shopping experiences.')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {values.map((value, index) => (
              <motion.div
                key={value.titleKey}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="card p-6 text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <value.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                  {t(value.titleKey)}
                </h3>
                <p className="text-gray-600 dark:text-gray-400">
                  {t(value.descKey)}
                </p>
              </motion.div>
            ))}
          </div>

          <div className="card p-8 text-center">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              {t('about.story_title', 'Our Story')}
            </h2>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
              {t('about.story_body')}
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;